// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
var V = function (x) {
    return x;
};
var validation = function (v) {
    return function (v1) {
        return function (v2) {
            if (v2 instanceof Data_Either.Left) {
                return v(v2.value0);
            };
            if (v2 instanceof Data_Either.Right) {
                return v1(v2.value0);
            };
            throw new Error("Failed pattern match at Data.Validation.Semigroup (line 50, column 1 - line 50, column 84): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var unV = function (dictWarn) {
    return validation;
};
var toEither = function (v) {
    return v;
};
var showV = function (dictShow) {
    return function (dictShow1) {
        return {
            show: function (v) {
                if (v instanceof Data_Either.Left) {
                    return "invalid (" + (Data_Show.show(dictShow)(v.value0) + ")");
                };
                if (v instanceof Data_Either.Right) {
                    return "pure (" + (Data_Show.show(dictShow1)(v.value0) + ")");
                };
                throw new Error("Failed pattern match at Data.Validation.Semigroup (line 87, column 10 - line 89, column 55): " + [ v.constructor.name ]);
            }
        };
    };
};
var newtypeV = {
    Coercible0: function () {
        return undefined;
    }
};
var isValid = function (v) {
    if (v instanceof Data_Either.Right) {
        return true;
    };
    return false;
};
var invalid = function ($59) {
    return V(Data_Either.Left.create($59));
};
var functorV = Data_Either.functorEither;
var foldableV = {
    foldMap: function (dictMonoid) {
        return validation(Data_Function["const"](Data_Monoid.mempty(dictMonoid)));
    },
    foldr: function (f) {
        return function (b) {
            return validation(Data_Function["const"](b))(Data_Function.flip(f)(b));
        };
    },
    foldl: function (f) {
        return function (b) {
            return validation(Data_Function["const"](b))(f(b));
        };
    }
};
var traversableV = {
    sequence: function (dictApplicative) {
        return validation((function () {
            var $60 = Control_Applicative.pure(dictApplicative);
            return function ($61) {
                return $60(V(Data_Either.Left.create($61)));
            };
        })())(Data_Functor.map((dictApplicative.Apply0()).Functor0())(function ($62) {
            return V(Data_Either.Right.create($62));
        }));
    },
    traverse: function (dictApplicative) {
        return function (f) {
            return validation((function () {
                var $63 = Control_Applicative.pure(dictApplicative);
                return function ($64) {
                    return $63(V(Data_Either.Left.create($64)));
                };
            })())((function () {
                var $65 = Data_Functor.map((dictApplicative.Apply0()).Functor0())(function ($67) {
                    return V(Data_Either.Right.create($67));
                });
                return function ($66) {
                    return $65(f($66));
                };
            })());
        };
    },
    Functor0: function () {
        return functorV;
    },
    Foldable1: function () {
        return foldableV;
    }
};
var eqV = function (dictEq) {
    return function (dictEq1) {
        return {
            eq: function (x) {
                return function (y) {
                    return Data_Eq.eq(Data_Either.eqEither(dictEq)(dictEq1))(x)(y);
                };
            }
        };
    };
};
var ordV = function (dictOrd) {
    return function (dictOrd1) {
        return {
            compare: function (x) {
                return function (y) {
                    return Data_Ord.compare(Data_Either.ordEither(dictOrd)(dictOrd1))(x)(y);
                };
            },
            Eq0: function () {
                return eqV(dictOrd.Eq0())(dictOrd1.Eq0());
            }
        };
    };
};
var eq1V = function (dictEq) {
    return {
        eq1: function (dictEq1) {
            return Data_Eq.eq(eqV(dictEq)(dictEq1));
        }
    };
};
var ord1V = function (dictOrd) {
    return {
        compare1: function (dictOrd1) {
            return Data_Ord.compare(ordV(dictOrd)(dictOrd1));
        },
        Eq10: function () {
            return eq1V(dictOrd.Eq0());
        }
    };
};
var bifunctorV = Data_Bifunctor.bifunctorEither;
var applyV = function (dictSemigroup) {
    return {
        apply: function (v) {
            return function (v1) {
                if (v instanceof Data_Either.Left && v1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(Data_Semigroup.append(dictSemigroup)(v.value0)(v1.value0));
                };
                if (v instanceof Data_Either.Left) {
                    return new Data_Either.Left(v.value0);
                };
                if (v1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(v1.value0);
                };
                if (v instanceof Data_Either.Right && v1 instanceof Data_Either.Right) {
                    return new Data_Either.Right(v.value0(v1.value0));
                };
                throw new Error("Failed pattern match at Data.Validation.Semigroup (line 95, column 1 - line 99, column 54): " + [ v.constructor.name, v1.constructor.name ]);
            };
        },
        Functor0: function () {
            return functorV;
        }
    };
};
var semigroupV = function (dictSemigroup) {
    return function (dictSemigroup1) {
        return {
            append: Control_Apply.lift2(applyV(dictSemigroup))(Data_Semigroup.append(dictSemigroup1))
        };
    };
};
var applicativeV = function (dictSemigroup) {
    return {
        pure: function ($68) {
            return V(Data_Either.Right.create($68));
        },
        Apply0: function () {
            return applyV(dictSemigroup);
        }
    };
};
var monoidV = function (dictSemigroup) {
    return function (dictMonoid) {
        return {
            mempty: Control_Applicative.pure(applicativeV(dictSemigroup))(Data_Monoid.mempty(dictMonoid)),
            Semigroup0: function () {
                return semigroupV(dictSemigroup)(dictMonoid.Semigroup0());
            }
        };
    };
};
var andThen = function (v1) {
    return function (f) {
        return validation(invalid)(f)(v1);
    };
};
export {
    V,
    validation,
    unV,
    invalid,
    isValid,
    toEither,
    andThen,
    newtypeV,
    eqV,
    eq1V,
    ordV,
    ord1V,
    showV,
    functorV,
    bifunctorV,
    applyV,
    applicativeV,
    semigroupV,
    monoidV,
    foldableV,
    traversableV
};
//# sourceMappingURL=index.js.map
